import React from "react";
import "./featured.scss";
import lemon from "../../Assets/images/lemon.png";
import carrot from "../../Assets/images/carrott.png";

const featuredCards = [
  {
    name: "Lemon",
    img: lemon,
    title: "Fruits",
    classNames: "featured-card featured-card-img1",
  },
  {
    name: "Carrot",
    img: carrot,
    title: "Veggies",
    classNames: "featured-card featured-card-img2",
    
  },
];

const Featured = () => {
  return (
    <div className="featured section">
      <div className="container">
        <div className="row">
          {featuredCards.map((featuredCard) => (
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-20" data-aos="fade-up">
              <div className={featuredCard.classNames}>
                <img src={featuredCard.img} alt={featuredCard.name} />
                <div className="featured-text">
                  <h4>{featuredCard.title}</h4>
                  <h4>100% </h4>
                  <span>Organic Products</span>
                  <button className="shop-btn">Shop now</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Featured;
